// Lectura defensiva de los params de URL propios de las cadencias del directivo
// (D1 ?cadencia= · D2 ?semana= · D3/D4 ?mes=). La URL es la fuente de verdad
// de la selección (refrescar / atrás la conservan); un valor ausente o
// malformado cae al default de la página, nunca a la API.

import type { Cadencia } from 'schemas';
import { esIsoValida } from './periodo';

const CADENCIAS: ReadonlySet<string> = new Set<Cadencia>(['hoy', 'semana', 'mes']);

/** `?cadencia=` de D1 → 'hoy' | 'semana' | 'mes'; cualquier otra cosa → default. */
export function leerCadenciaParam(valor: string | null, porDefecto: Cadencia = 'hoy'): Cadencia {
  return valor && CADENCIAS.has(valor) ? (valor as Cadencia) : porDefecto;
}

/** `?semana=` de D2: fecha calendario YYYY-MM-DD (la API recibe una fecha de la
 *  semana). Inválida o ausente → null (semana operativa en curso). */
export function leerSemanaParam(valor: string | null): string | null {
  return esIsoValida(valor) ? valor : null;
}

/** `?mes=` de D3/D4: la API recibe una FECHA (YYYY-MM-DD) del mes. Se acepta
 *  también la forma corta YYYY-MM (→ día 1). Inválido o ausente → null (mes en
 *  curso). */
export function leerMesParam(valor: string | null): string | null {
  if (!valor) return null;
  if (/^\d{4}-\d{2}$/.test(valor)) {
    const dia1 = `${valor}-01`;
    return esIsoValida(dia1) ? dia1 : null;
  }
  return esIsoValida(valor) ? valor : null;
}
